<template>
  <div>
    <div v-if="datos" style="display: grid; margin-bottom: 20px;">
      <label>Operarios</label>
      <select class="form-control" v-model="operarioSeleccionado">
        <option v-for="operario in Object.entries(datos.operarios)" :key="operario[0]" :value="operario[0]">
          {{ operario[1].nombre }}
        </option>
      </select>
    </div>

    <div id="calendar-container"></div>
    <div style="margin-top: 15px; display: flex; gap: 15px; align-items: end;">
      <div style="display: grid;">
        <label for="">Método de cálculo de huecos</label>
        <select style="width: 100%;" class="form-control" v-model="calculo_huecos" id="">
          <option value="-">Solo desde visitas ya dadas</option>
          <option value="1">1º Desde Visitas ya dadas 2º Desde la dirección del operario</option>
        </select>
      </div>
      <button class="btn btn-primary" @click="actualizarEventosOperario()">Guardar</button>
    </div>

    <div v-if="operarios_sin_coordenadas" style="margin-top: 15px; width: 50%;">
      <label>Operarios sin coordenadas</label>
      <table class="table table-sm table-striped table-bordered">
        <thead>
          <tr>
            <th>Operario</th>
            <th>Población</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="oper in Object.entries(operarios_sin_coordenadas)" :key="oper[0]">
            <td>{{ oper[1].nombre }}</td>
            <td>{{ oper[1].poblacion_operario }}</td>
          </tr>
        </tbody>
      </table>
      <button class="btn btn-light" style="border: 1px solid grey; margin-top: 5px" @click="calcularCoordenadas()">Calcular coordenadas</button>
    </div>  
  </div>
</template>

<script>
// Importaciones correctas para FullCalendar 5.11.5
import { Calendar } from '@fullcalendar/core'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import esLocale from '@fullcalendar/core/locales/es'

// Importaciones de CSS para FullCalendar 5.11.5
import '@fullcalendar/common/main.css'
import '@fullcalendar/daygrid/main.css'
import '@fullcalendar/timegrid/main.css'
import { PwgsApi } from '../../../../services/PwgsApi'

export default {
  props: ['datos'],
  data() {
    return {
      operarioSeleccionado: '',
      calendar: null,
      eventos: [],
      calculo_huecos:1,
      oper_sin_coord:'',
      operarios_sin_coordenadas:[],
    }
  },
  methods: {
    async calcularCoordenadas(){
      const api = new PwgsApi();
      try{
        await api.put('pwgs-autovisita/calcular-coordenadas');
        this.$toast.add({ severity: 'success', summary: 'Actualizado', detail: 'Coordenadas actualizadas, los operarios que queden sin coordenadas se les deberá revisar sus direcciones', life: 7000 });
        this.$emit('cambioSinCoords');
      }catch(e){
        this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });
      }      
    },
    async actualizarEventosOperario() {
      const api = new PwgsApi();
      if (this.eventos.length > 0) {
        const calendar = this.eventos.map(ev => {
          // Convertimos a objeto Date si no lo son
          const start = typeof ev.start === 'string' ? new Date(ev.start) : ev.start;
          const end = typeof ev.end === 'string' ? new Date(ev.end) : ev.end;

          // Día de la semana (0 = domingo, 6 = sábado) => lunes = 1, domingo = 7
          const numDia = start.getDay() === 0 ? 7 : start.getDay();

          // Hora en formato HH:MM:SS
          const inicio = start.toTimeString().slice(0, 8);
          const fin = end.toTimeString().slice(0, 8);

          return {
            numDia,
            inicio,
            fin
          };
        });
        try{
          await api.put('pwgs-autovisita/'+this.operarioSeleccionado+'/autovisitas-operario', {calendario:calendar, huecos_desde_casa: this.calculo_huecos});
          this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Cambios guardados', life: 2000 });
          this.$emit('cambioSinCoords');
        }catch(e){
          this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });
        }
      }
    },
    actualizar(sinCoords){
      this.operarios_sin_coordenadas = sinCoords;
    },
    cargarDatos() {
      this.operarios_sin_coordenadas = this.datos.operarios_sin_coordenadas;
      let num = 0
      for (let [key, oper] of Object.entries(this.datos.operarios)) {
        if (this.datos.operarios_con_autovisita.includes(key)) {
          oper.nombre += ' [Configurada Autovisita]'
        }
        if (num === 0) this.operarioSeleccionado = key
        num++
      }
    },
    async getEventosParaOperario(operario) {
      const api = new PwgsApi();
      const eventosRaw = await api.post('pwgs-autovisita', { id_operario: operario });

      if(eventosRaw.length == 0){
        this.vaciarEventos();
        return;
      }

      // 1. Calcular el lunes de la semana actual
      const hoy = new Date();
      const diaSemana = hoy.getDay(); // 0 (domingo) a 6 (sábado)
      const offset = diaSemana === 0 ? -6 : 1 - diaSemana; // si es domingo (0), restamos 6
      const lunesSemanaActual = new Date(hoy);
      lunesSemanaActual.setDate(hoy.getDate() + offset);

      // 2. Construir los eventos a partir del lunes actual
      const eventosProcesados = eventosRaw.map(ev => {
        const dia = new Date(lunesSemanaActual);
        dia.setDate(dia.getDate() + (parseInt(ev.dia_semana, 10) - 1));

        const fechaStr = dia.toISOString().split('T')[0]; // yyyy-mm-dd
        return {
          id: ev.id,
          title: 'Autovisita',
          start: `${fechaStr}T${ev.hora_inicio}`,
          end: `${fechaStr}T${ev.hora_fin}`,
          extendedProps: ev
        };
      });

      this.eventos = eventosProcesados;
      this.actualizarEventos();
    },
    vaciarEventos(){
      if (this.calendar) {
        this.calendar.getEventSources().forEach(source => source.remove())
      }
      this.eventos = [];
    },
    actualizarEventos() {
      if (this.calendar) {
        this.calendar.getEventSources().forEach(source => source.remove())
        this.calendar.addEventSource(this.eventos)
      }
    },
    onEventChange(info) {
      const eventoActualizado = {
        id: info.event.id,
        title: info.event.title,
        start: info.event.start,
        end: info.event.end,
        ...info.event.extendedProps
      }
      this.confirmarevento(eventoActualizado, 'redimensiona')
    },
    onEventClick(info) {
      if(info.event.extendedProps.id){
        if (confirm('¿Eliminar este evento?')) {
          info.event.remove()
          this.eliminarVisita(info.event)
        }
      }else{
        return;
      }
    },
    async eliminarVisita(evento) {
      const api = new PwgsApi();     
      try{
        await api.delete('pwgs-autovisita/'+evento.id);
        this.eventos = this.eventos.filter(e => e.id !== evento.id);
        this.actualizarEventos();
        this.$emit('cambioSinCoords');
        this.$toast.add({ severity: 'success', summary: 'Eliminado', detail: 'Registro eliminado', life: 2000 });        
      }catch(e){
        this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });
      }
      
    },
    confirmarevento(evento) {
      this.eventos.forEach(ev => {
        if (ev.id === evento.id) {
          ev.actualizado = true;
          ev.start = evento.start;
          ev.end = evento.end;
        }
      })
    },
    forzarRenderCalendario() {
        if (!this.calendar) {
            this.inicializarCalendario();
        } else {
            this.calendar.render(); // fuerza recalcular medidas
        }
    },

    onSelect(selectionInfo) {
      const { start, end } = selectionInfo;

      const eventosDivididos = [];

      const current = new Date(start);

      while (current < end) {
        const eventoInicio = new Date(current);
        const eventoFin = new Date(current);

        // Si es el primer día, comienza desde `start`
        if (current.toDateString() === start.toDateString()) {
          eventoInicio.setTime(start.getTime());
        } else {
          eventoInicio.setHours(0, 0, 0, 0);
        }

        // Si es el último día, termina en `end`
        if (new Date(current.getFullYear(), current.getMonth(), current.getDate()).toDateString() === end.toDateString()) {
          eventoFin.setTime(end.getTime());
        } else {
          eventoFin.setHours(23, 59, 59, 999);
        }

        eventosDivididos.push({
          id: String(Date.now() + Math.random()), // id único
          start: new Date(eventoInicio),
          end: new Date(eventoFin),
          extendedProps: {}
        });

        // avanzar al día siguiente
        current.setDate(current.getDate() + 1);
      }

      this.eventos.push(...eventosDivididos);
      this.actualizarEventos();
      this.calendar.unselect();
    },

    inicializarCalendario() {
      const calendarEl = document.getElementById('calendar-container')
      if (calendarEl && !this.calendar) {
        this.calendar = new Calendar(calendarEl, {
            plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
            locale: esLocale,
            initialView: 'timeGridWeek',
            headerToolbar: false,
            editable: true,
            slotLabelInterval: '01:00',
            slotDuration: '01:00',
            slotMinTime: '00:00:00',
            slotMaxTime: '23:59:59',
            events: this.eventos,
            allDaySlot: false,
            eventDurationEditable: true,
            eventResizableFromStart: true,
            selectable: true,
            selectMirror: true,
            select: this.onSelect,
            height: 500,
            eventChange: this.onEventChange,
            eventClick: null,
            eventContent: (arg) => {
              const start = arg.event.start;
              const end = arg.event.end;

              // Formatear horas como "08:00 - 17:00"
              const formatHora = (fecha) => {
                const horas = fecha.getHours().toString().padStart(2, '0');
                const minutos = fecha.getMinutes().toString().padStart(2, '0');
                return `${horas}:${minutos}`;
              };
              const horaTexto = `${formatHora(start)} - ${formatHora(end)}`;

              const horaEl = document.createElement('div');
              horaEl.innerText = horaTexto;
              horaEl.style.flex = '1';

              const closeBtn = document.createElement('div');
              closeBtn.innerText = 'X';
              closeBtn.style.backgroundColor = '#1E90FF'; // azul tipo botón
              closeBtn.style.color = 'white';
              closeBtn.style.padding = '2px 6px';
              closeBtn.style.borderRadius = '4px';
              closeBtn.style.cursor = 'pointer';
              closeBtn.style.fontSize = '12px';
              closeBtn.style.fontWeight = 'bold';

              closeBtn.addEventListener('click', (ev) => {
                ev.stopPropagation(); // evitar eventClick
                if(arg.event.extendedProps.id){
                  if (confirm('¿Eliminar este evento?')) {
                    this.eliminarVisita(arg.event);
                    arg.event.remove();
                    this.eventos.forEach((ev) => {
                      if (ev.id === arg.event.extendedProps.id) {
                        this.eventos.splice(this.eventos.indexOf(ev), 1);
                      }
                    })
                  }
                }else{
                  arg.event.remove();
                  this.eventos.forEach((ev) => {
                    if (ev.id === arg.event.id) {
                      this.eventos.splice(this.eventos.indexOf(ev), 1);
                    }
                  })
                }
              });

              const container = document.createElement('div');
              container.style.display = 'flex';
              container.style.justifyContent = 'space-between';
              container.style.alignItems = 'center';

              container.appendChild(horaEl);
              container.appendChild(closeBtn);

              return { domNodes: [container] };
            }
        });
        
        this.calendar.render()
      }
    },    
  },
  mounted() {
    if (this.datos) {
      this.cargarDatos()
    }
    
    // Inicializar el calendario después de que el DOM esté listo
    this.$nextTick(() => {
        if (this.$el.offsetParent !== null) {
        this.inicializarCalendario()
        }
    })
  },
  beforeUnmount() {
    // Limpiar el calendario cuando el componente se desmonta
    if (this.calendar) {
      this.calendar.destroy()
      this.calendar = null
    }
  },
  watch: {
    datos() {
      this.cargarDatos();
    },
    operarioSeleccionado(newOperario) {
      this.getEventosParaOperario(newOperario);      
    }
  }
}
</script>

<style scoped>
#calendar-container {
  height: 800px;
  width: 100%;
}

.fc-event-title-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.fc-event-title::after {
  content: ' x';
  margin-left: 6px;
  color: red;
  cursor: pointer;
}
</style>